<template>
  <div>
    <base-header class="pb-6" type="">
      <div class="row align-items-center py-4">
        <div class="col-lg-6 col-7">
          <h6 class="h2 d-inline-block mb-0">Inspection Reports</h6>
        </div>
      </div>
    </base-header>

    <!--Charts-->
    <div class="container-fluid mt--6"  v-loading="loading">
      <div class="card-deck flex-column flex-xl-row">
        <card header-classes="bg-transparent">
          <div slot="header" class="row align-items-center">
            <div class="col">
              <h5 class="h3 mb-0">Total Inspections</h5>
            </div>
          </div>
          <line-chart :height="350" ref="bigChart" :chart-data="inspectionCount" :extra-options="inspectionChartOptions('total')">
          </line-chart>
        </card>

        <card header-classes="bg-transparent">
          <div slot="header" class="row align-items-center">
            <div class="col">
              
              <h5 class="h3 mb-0">Average Inspections <h6 class="text-uppercase text-muted ls-1 mb-1 d-inline-block">Per Lead</h6></h5>
            </div>
          </div>
          <line-chart :height="350" ref="bigChart" :chart-data="inspectionAverage" :extra-options="inspectionChartOptions('average')">
          </line-chart>
        </card>
      </div>
      <div class="card-deck flex-column flex-xl-row">
        <card header-classes="bg-transparent">
          <div slot="header" class="row align-items-center">
            <div class="col">
              <h5 class="h3 mb-0">Inspections By City</h5>
            </div>
          </div>
          <line-chart :height="350" ref="bigChart" :chart-data="inspectionCity" :extra-options="inspectionChartOptions('total')">
          </line-chart>
        </card>
      </div>
      <div class="card-deck flex-column flex-xl-row">
        <card header-classes="bg-transparent">
          <div slot="header" class="row align-items-center">
            <div class="col">
              <h5 class="h3 mb-0">Inspection By Venue Specialists</h5>
            </div>
          </div>
          <line-chart :height="350" ref="bigChart" :chart-data="inspectionVenueSpecialist" :extra-options="inspectionChartOptions('total')">
          </line-chart>
        </card>
      </div>
      <!-- End charts-->
    </div>
  </div>
</template>
<script>
// Charts
import LineChart from "@/components/Charts/LineChart";

// Components

import ReportsService from "@/services/reports.service";
import { mapState } from "vuex";

export default {
  data() {
    return {
      loading: true,
    };
  },
  components: {
    LineChart,
  },
  async created() {
    await this.$store.dispatch("reports/getInspections");
    this.loading = false;
  },
  computed: mapState({
    inspectionCount(state) {
      return ReportsService.formatSingleKeyValues(state.reports.inspections.total || {uk: {}, au: {}});
    },
    inspectionAverage(state) {
      return ReportsService.formatSingleKeyValues(state.reports.inspections.avg || {uk: {}, au: {}});
    },
    inspectionCity(state) {
      return ReportsService.formatMultipleKeyValues(state.reports.inspections.city || [], 'city');
    },
    inspectionVenueSpecialist(state) {
      return ReportsService.formatMultipleKeyValues(state.reports.inspections.venue_specialist || [], 'venue_specialist_name');
    },
  }),
  methods: {
    inspectionChartOptions(type) {
      return {
        legend: {
          display: true,
          position: 'bottom',
        },
        scales: {
          xAxes: [{
            stacked: false,
            categoryPercentage: 0.5,
            barPercentage: 1,
            ticks: {
              callback: function(label, index, labels) {
                return label.substr(0, 3);
              },
            },
          }],
          yAxes: [{
            stacked: false,
            ticks: {
              callback: function(label) {
                return new Intl.NumberFormat( 'en-US', { maximumFractionDigits: 1,notation: "compact" , compactDisplay: "short" }).format(label);
              },
            },
          }],
        },
      }; 
    },
  },
};
</script>
<style></style>
